import React from 'react'
import { LayoutSubmenuCP } from 'submodules/nerit-framework-ui/common/components/screen/layout-with-submenu/layout/LayoutSubmenuCP'
import { TitleBrowserCP } from 'submodules/nerit-framework-ui/common/components/title-browser/TitleBrowserCP'
import { ChartsScreenUtils, CHARTS, ScreenChartsViewTP } from 'modules/reports/screens/screen-charts/inner/ChartsScreenUtils'
import { AppStateUtils } from 'app/redux/AppStateUtils'

/**
 */
export function ScreenCharts(): JSX.Element {

    return (
        <>
            <TitleBrowserCP pageName={'Ferramentas de Análise'} />
            <LayoutSubmenuCP<ScreenChartsViewTP>
                menuTitle={'Ferramentas de Análise'}
                loggedDomain={AppStateUtils.getDomainData()?.slug}
                defaultSubmenu={'historical'}
                defaultOpenKeys={[CHARTS]}
                submenuConfigs={ChartsScreenUtils.getSubMenuConfigs()}
            />
        </>
    )
}
